<template>
  <v-container fluid>
    <PaginationController
      v-model="labels"
      getDataActionName="getLabelPagination"
      :historyLimit="historyLimit"
      :haveSearchBox="true"
      :select="(selectedBalanceTable || {}).clientKey"
      :showSearchBoxLabel="false"
      :actionPredicates="generatePredicate()"
      :isStartWithoutData="true"
    >
      <template v-slot:dataTable>
        <v-data-table
          :headers="headers"
          :items="labels"
          hide-actions
          :search="filterText"
          item-key="orderId"
        >
          <template v-slot:items="props">
            <td class="text-xs-center">
              {{ props.index + 1 }}
            </td>
            <td class="text-xs-left">
              <LabelDetailsWidget
                :shipmentLabel="props.item"
                :index="props.index"
              />
            </td>
            <td class="text-xs-left">
              <LabelAddressWidget
                :address="props.item.from"/>
            </td>
            <td class="text-xs-left">
              <LabelAddressWidget
                :address="props.item.to"/>
            </td>
            <td v-if="$store.getters.activeWarehouse" class="text-xs-left">
              {{ organizationKeyToId.get(props.item.clientKey) }}
            </td>
            <td class="text-xs-left">
              <v-layout>
                {{ toDateYYYYMMDDHHmm(props.item.createTime) }}
              </v-layout>
              <v-layout>
                {{ props.item.shipDate }}
              </v-layout>
              <v-layout v-if="props.item.estimatedDelivery && props.item.estimatedDelivery !== 'N/A'" class="text-capitalize">
                <v-flex v-if="typeof props.item.estimatedDelivery === 'string'">{{
                  toDateYYYYMMDDHHmm(new Date(props.item.estimatedDelivery))
                }}</v-flex>
                <v-flex v-else>{{ toDateYYYYMMDDHHmm(props.item.estimatedDelivery) }}</v-flex>
              </v-layout>
            </td>
            <td class="text-xs-left">
              <template v-if="props.item.status !== 'failed'">
                <LabelTrackingDetailWidget
                  v-if="props.item.status !== 'failed'"
                  :trackingNumber="props.item.trackingNumber"
                  :status="props.item.status"
                  :carrier="props.item.carrier"
                  :details="props.item.trackingDetails"
                />
                <div v-if="['ready', 'in transit', 'delivered'].includes(props.item.status) && !!props.item.trackStatus">{{ props.item.trackStatus.toLowerCase() }}</div>
              </template>
              <div v-else>
                <p :key="messageItem.time" v-for="messageItem in props.item.messages" >
                  {{messageItem.message}}
                </p>
              </div>
            </td>
            <td class="text-xs-left">{{ props.item.serviceDescription }}</td>
            <td :class="props.item.totalAmount ? 'text-xs-left fontRed' : (props.item.amount > 0 ? 'text-xs-left fontGreen' : 'text-xs-left fontRed')">
              ${{ -props.item.totalAmount || props.item.amount || 0 }}
            </td>
            <td class="text-xs-left">{{ getStatusText(props.item) }}</td>
            <td class="text-xs-left" v-show="false">{{ props.item.trackingNumbers && props.item.trackingNumbers.join(',') || '' }}</td>
            <td class="text-xs-center">
              <v-layout row>
                <v-flex v-if="props.item.status === 'pending'">
                  <v-tooltip top>
                    <template v-slot:activator="tooltip">
                      <div v-on="tooltip.on">
                        <LoaderButton
                          flat
                          buttonIcon='refresh'
                          :promiseAwait="getLabelStatus"
                          :promiseItem="props.item"/>
                      </div>
                    </template>
                    {{ $t('getStatus') }}
                  </v-tooltip>
                </v-flex>
                <v-flex v-else>
                  <v-tooltip top>
                    <template v-slot:activator="tooltip">
                      <div v-on="tooltip.on">
                        <v-btn
                          dark
                          flat
                          color="primary"
                          @click.stop="downloadFile(props.item.url, props.item.orderId)"
                          :disabled="!props.item.url"
                          icon
                        >
                        <v-icon>preview</v-icon></v-btn>
                      </div>
                    </template>
                    {{ $t('openLabel') }}
                  </v-tooltip>
                </v-flex>
                <v-flex v-if="props.item.invoiceUrl">
                  <v-tooltip top>
                    <template v-slot:activator="tooltip">
                      <div v-on="tooltip.on">
                        <v-btn
                          flat
                          icon
                          color="orange"
                          @click.stop="downloadFile(props.item.invoiceUrl, props.item.orderKey, props.item._key)"
                          :disabled="['canceled', 'failed'].includes(props.item.status)"
                        ><v-icon>receipt</v-icon></v-btn>
                      </div>
                    </template>
                    {{ $t('downloadInvoice') }}
                  </v-tooltip>
                </v-flex>
                <v-flex>
                  <v-menu v-if="props.item.trackingNumbers && props.item.trackingNumbers.length > 1" bottom left>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" flat small>
                      {{ $t('proofDelivery') }}
                      </v-btn>
                    </template>
                    <v-list dense>
                      <v-subheader>{{ $t('trackingNumber') }}</v-subheader>
                      <v-list-tile
                        v-for="trackingNumber in props.item.trackingNumbers"
                        :key="trackingNumber"
                        @click="proofDelivery(props.item, trackingNumber)"
                      >
                        <v-list-tile-title>{{ trackingNumber }}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                  <v-tooltip top v-else>
                    <template v-slot:activator="tooltip">
                      <div v-on="tooltip.on">
                        <LoaderButton
                          flat
                          :buttonText="$t('proofDelivery')"
                          :disabled="!props.item.trackingNumber"
                          :promiseAwait="() => proofDelivery(props.item)"
                          :promiseItem="props.item"
                        ></LoaderButton>
                      </div>
                    </template>
                    {{ $t('proofDelivery') }}
                  </v-tooltip>
                </v-flex>
                <v-flex>
                  <v-tooltip top>
                    <template v-slot:activator="tooltip">
                      <div v-on="tooltip.on">
                        <LoaderButton
                          v-if="!['canceled', 'failed'].includes(props.item.status)"
                          flat
                          :promiseAwait="cancelLabel"
                          :promiseItem="props.item"
                          buttonIcon='delete'
                        ></LoaderButton>
                      </div>
                    </template>
                    {{ $t('delete') }}
                  </v-tooltip>
                </v-flex>
              </v-layout>
            </td>
          </template>
        </v-data-table>
      </template>
      <template v-slot:beforeMenu>
        <v-layout justify-start>
          <v-flex xs4 mr-1>
            <v-select
              :items="[
                { name: $t('keyword'), value: 'keyword' },
                { name: $t('batchByRequestId'), value: 'requestIds' },
                { name: $t('batchByTracking'), value: 'trackings' },
              ]"
              item-value="value"
              item-text="name"
              v-model="searchMode"
              @change="
                e => {
                  searchText = ''
                  requestIds = []
                  selectStatus = ''
                  searchTrackings = []
                  trackStatusValue = ''
                }
              "
              :label="$t('searchMode')"
            ></v-select>
          </v-flex>
          <v-flex xs8 pl-3 v-if="searchMode === 'trackings'">
            <v-combobox
              :label="`${$t('tracking')}(max: 10)`"
              v-model="searchTrackings"
              small-chips
              deletable-chips
              @change="changeBatchSearch(searchTrackings, 'searchTrackings')"
              :return-object="false"
              :hint="`${$t('trackingNumber')} **${$t('enterToNext')}`"
              multiple
              clearable
            />
          </v-flex>
          <v-flex xs8 pl-3 v-if="searchMode === 'requestIds'">
            <v-combobox
              :label="`${$t('requestId')}(max: 10)`"
              v-model="requestIds"
              small-chips
              deletable-chips
              @change="changeBatchSearch(requestIds, 'requestIds')"
              :return-object="false"
              :hint="`${$t('requestId')} **${$t('enterToNext')}`"
              multiple
              clearable
            />
          </v-flex>
          <template v-if="searchMode === 'keyword'">
            <v-flex xs2>
              <v-autocomplete
                :items="labelStatusArray"
                item-value="value"
                item-text="name"
                v-model="selectStatus"
                :label="$t('labelStatus')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs2 ml-1>
              <v-autocomplete
                :items="trackStatusArray"
                item-value="value"
                item-text="name"
                v-model="trackStatusValue"
                :label="$t('trackStatus')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs4 ml-3>
              <v-text-field
                :hint="`${$t('memo')}/${$t('recipient')}/${$t('serviceType')}/${$t('tracking')}`"
                :label="$t('search')"
                v-model="searchText"
                clearable
              ></v-text-field>
            </v-flex>
          </template>
          <v-flex xs1></v-flex>
          <v-flex xs4>
            <v-autocomplete
              :label="$t('selectOrg')"
              v-model="selectedBalanceTable"
              return-object
              item-text="clientName"
              :items="balances"
              clearable></v-autocomplete>
          </v-flex>
        </v-layout>
      </template>
      <template v-slot:afterDate>
        <v-flex xs4>
          <v-text-field
            :label="$t('filter')"
            v-model="filterText"
            clearable
          ></v-text-field>
        </v-flex>
      </template>
    </PaginationController>
  </v-container>
</template>

<script>
import { splitKeyword } from '@/utils/tools'
import Label from './Label'
import LabelDetailsWidget from './LabelDetailsWidget.vue'

export default {
  components: { LabelDetailsWidget },
  name: 'LabelAdmin',
  extends: Label,
  data () {
    return {
      selectedBalance: {},
      selectedBalanceTable: {},
      headers: [
        { text: '#', value: '', align: 'center', sortable: false },
        { text: this.$t('details'), value: 'signature', align: 'left', sortable: false },
        { text: this.$t('from'), value: 'from', align: 'left', sortable: false },
        { text: this.$t('to'), value: 'to', align: 'left', sortable: false },
        { text: this.$t('create/ShipDate'), value: 'createTime', align: 'left', sortable: false },
        { text: this.$t('tracking/info'), value: 'trackingNumber', align: 'left', sortable: false },
        { text: this.$t('service'), value: 'shippingService', align: 'left', sortable: false },
        { text: this.$t('amount'), value: 'amount', align: 'left', sortable: false },
        { text: this.$t('status'), value: 'status', align: 'left', sortable: false },
        { text: this.$t('trackingNumbers'), value: 'trackingNumbers', align: 'left', sortable: false, class: 'header-hidden' },
        { text: this.$t('actions'), value: '', align: 'center', sortable: false }
      ],
      labels: [],
      loading: false,
      requestIds: [],
      searchMode: 'keyword',
      searchText: '',
      searchTrackings: [],
      filterText: '',
      selectStatus: ''
    }
  },
  async created () {
    this.$store.dispatch('getAllSystemBalances')
    this.$store.dispatch('loadSystemInfo')
  },
  destroyed () {
    this.$store.getters.subscribed['systemSetting']()
  },
  computed: {
    balances () {
      return this.$store.getters.systemBalances
    }
  },
  watch: {
    balances (value) {
      this.selectedBalanceTable = value.find(item => item.clientKey === this.selectedBalanceTable.clientKey) || {}
    }
  },
  methods: {
    getStatusText (item) {
      // const trackingStatuses = ['ready', 'in transit', 'delivered']
      // if (trackingStatuses.includes(item.status) && !!item.trackStatus) {
      return item.status
      // }
      // return item.status || 'ready'
    },
    changeBatchSearch (arr = [], fieldName) {
      arr = arr.reduce((resArr, currItem) => {
        return resArr.concat(splitKeyword(currItem))
      }, [])
      this.$set(this, fieldName, arr.filter(item => item))
    },
    generatePredicate () {
      const { searchText, trackStatusValue, requestIds = [], searchTrackings = [], selectStatus = '' } = this
      const predicate = []
      const toUpperStr = str => str.trim().toUpperCase()
      if (requestIds.length) {
        predicate.push({
          field: 'requestId',
          compare: 'in',
          value: requestIds.map(toUpperStr).slice(0, 10)
        })
      }
      if (searchTrackings.length) {
        predicate.push({
          field: `trackingNumber`,
          compare: 'in',
          value: searchTrackings.map(toUpperStr).slice(0, 10)
        })
      }
      if (searchText) {
        predicate.push({
          field: `keywords`,
          compare: 'array-contains',
          value: searchText.trim().toLowerCase()
        })
      }
      if ((this.selectedBalanceTable || {}).clientKey) {
        predicate.push({
          field: `clientKey`,
          compare: '==',
          value: (this.selectedBalanceTable || {}).clientKey
        })
      }
      if (selectStatus) {
        predicate.push({
          field: `status`,
          compare: '==',
          value: selectStatus
        })
      }
      if (trackStatusValue) {
        predicate.push({
          field: `trackStatus`,
          compare: 'in',
          value: [trackStatusValue.toLowerCase(), trackStatusValue.toUpperCase()]
        })
      }
      return predicate
    },
    async cancelLabel (label) {
      if (!confirm(label.shipmentId ? this.$t('canceledShipmentIdAdmin', { shipmentId: label.shipmentId }) : this.$t('confirmCancelAdmin', {name: this.$t('label')}))) return Promise.resolve()
      this.isLoading = true
      try {
        await this.$store.dispatch('cancelLabel', label)
        this.labels
          .forEach(item => {
            if (item.requestId === label.requestId) {
              this.$set(item, 'status', 'canceled')
            }
          })
        this.isLoading = false
      } catch (err) {
        alert(err.message)
        this.isLoading = false
      }
    },
    async proofDelivery (item, trackingNumber = null) {
      const { isProofDelivery, filePathDownloadURL, trackingNumbers } = item
      if (isProofDelivery) {
        if (trackingNumbers && trackingNumbers.length > 1 && trackingNumber) {
          if (filePathDownloadURL && filePathDownloadURL.includes(trackingNumber)) {
            this.downloadPoofDeliveryFile(filePathDownloadURL)
            return
          }
        } else {
          this.downloadPoofDeliveryFile(filePathDownloadURL)
          return
        }
      }
      if (!confirm(this.$t('confirmProofDelivery'))) return
      await this.getProofDeliveryFile(item, trackingNumber)
    },
    async updateProofDelivery (item, trackingNumber = null) {
      const { isProofDelivery } = item
      if (!isProofDelivery || !confirm(this.$t('confirmUpdateProofDelivery'))) return
      await this.getProofDeliveryFile(item, trackingNumber)
    },
    async getProofDeliveryFile (item, trackingNumber = null) {
      const { requestId } = item
      const trackingNumberToUse = trackingNumber || item.trackingNumber
      try {
        const { data = {} } = await this.$store.dispatch('getLabelProofDelivery', { trackingNumber: trackingNumberToUse, requestId })
        this.downloadPoofDeliveryFile(data.filePathDownloadURL)
        this.$set(item, 'isProofDelivery', true)
        item.filePathDownloadURL = data.filePathDownloadURL
      } catch (err) {
        let msg = err.message
        if (msg.includes('is not currently available')) msg = this.$t('proofDeliveryError')
        console.log(msg)
        alert(msg)
      }
    },
    downloadPoofDeliveryFile (fullPath, fileName) {
      if (!fullPath) return
      const link = document.createElement('a')
      link.href = fullPath
      link.style.display = 'none'
      link.download = fileName
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>

<style scoped>
  /deep/ .header-hidden {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/LabelAdmin.vue